import { useEffect, useRef, useState } from 'react';
import { useAppStore } from '@/hooks/use-app-store';

export const Cauldron = () => {
  const cauldronVideoRef = useRef<HTMLVideoElement>(null);
  const smokeVideoRef = useRef<HTMLVideoElement>(null);
  const [isSmokeEffectPlaying, setIsSmokeEffectPlaying] = useState(false);
  const { sub, unsub } = useAppStore();

  useEffect(() => {
    // Start cauldron video
    const cauldronVideo = cauldronVideoRef.current;
    if (cauldronVideo) {
      cauldronVideo.play().catch(console.error);
    }
  }, []);

  // Listen for smoke effect triggers from AI
  useEffect(() => {
    const handleSmokeEffect = () => {
      const smokeVideo = smokeVideoRef.current;
      if (smokeVideo && !isSmokeEffectPlaying) {
        setIsSmokeEffectPlaying(true);
        smokeVideo.currentTime = 0; // Reset to beginning
        smokeVideo.play().catch(console.error);
      }
    };

    // Subscribe to cauldron smoke effect events
    sub('cauldron_smoke_effect', handleSmokeEffect);

    return () => {
      unsub('cauldron_smoke_effect', handleSmokeEffect);
    };
  }, [sub, unsub, isSmokeEffectPlaying]);

  const handleSmokeVideoEnded = () => {
    setIsSmokeEffectPlaying(false);
  };

  return (
    <div className="cauldron-container fixed inset-0 pointer-events-none z-[1]">
      {/* Cauldron video - larger than DOM size */}
      <video
        ref={cauldronVideoRef}
        src="/webm/Cauldron_1.webm"
        autoPlay
        loop
        muted
        playsInline
        className="absolute w-[120%] h-[120%] object-contain"
        style={{
          top: '-20%',
          left: '0%',
          transform: 'scale(2)'
        }}
      />
      
      {/* Cauldron smoke effect - triggered by AI, plays once */}
      <video
        ref={smokeVideoRef}
        src="/webm/Cauldron_smokeeffect.webm"
        muted
        playsInline
        onEnded={handleSmokeVideoEnded}
        className="absolute w-[120%] h-[120%] object-contain"
        style={{
          top: '-20%',
          left: '0%',
          transform: 'scale(2)',
          opacity: isSmokeEffectPlaying ? 1 : 0,
          transition: 'opacity 0.3s ease-in-out'
        }}
      />
    </div>
  );
};
